export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('AssignRandomId', (field) => ({
        id: `${field}-${Math.random().toString(36).substring(7)}`,
        assignUniqueID() {
          document.getElementById(`${field}-placeholder`).id = this.id;
        },
      }));
    });
  },
};
